module.exports = __webpack_public_path__ + "img/5g-1.c136db8e.png";